module.exports = "<div class=\"dashboard-container\">\n  <div class=\"stats-banner\">\n    <personal-queue></personal-queue>\n    <global-queue></global-queue>\n    <average-visit-time></average-visit-time>\n    <!-- <visits-per-hour></visits-per-hour> -->\n    <visits-today></visits-today>\n    <earnings-today [last]=\"true\"></earnings-today>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main